{
    "CX_Record_Licences_None": "Nessuno",
    "CX_Record_Licences_CXRRecord": "Referto radiografico del torace",
    "CX_Record_Licences_CXRUser": "Utente CXR",
    "CX_Record_Licences_CXRManager": "CXR Manager",
    "CX_Record_Device_Or_Agent_Error": "Per un abbonamento {} è necessario un agente o un dispositivo",
    "NAME": "CXRecordLanguage"
}